/** Viewport breakpoint (px) at which the dock switches to desktop side-panel mode. */
export const DOCK_LG_BREAKPOINT = 992;

/** Dock occupies at least 25 % of the viewport width. */
export const DOCK_MIN_WIDTH_RATIO = 0.25;

/** Dock occupies at most 33.33 % of the viewport width. */
export const DOCK_MAX_WIDTH_RATIO = 0.3333;

/** Fallback pixel width used on SSR where `window` is unavailable. */
export const DOCK_SSR_FALLBACK_WIDTH = 320;

/**
 * Returns true when the viewport is wide enough for the desktop side-panel dock.
 * @param viewportWidth  Current viewport width in pixels
 */
export function isDesktopDock(viewportWidth: number): boolean {
  return viewportWidth >= DOCK_LG_BREAKPOINT;
}

/**
 * Clamp a desired pixel width to the DOCK_MIN_WIDTH_RATIO ↔ DOCK_MAX_WIDTH_RATIO
 * bounds of the given viewport width.
 * @param viewportWidth  Current viewport width in pixels
 * @param px             Desired width in pixels
 */
export function clampDockWidth(viewportWidth: number, px: number): number {
  return Math.min(
    Math.max(px, viewportWidth * DOCK_MIN_WIDTH_RATIO),
    viewportWidth * DOCK_MAX_WIDTH_RATIO,
  );
}

/**
 * Returns the default dock width (DOCK_MIN_WIDTH_RATIO of the viewport), rounded to a whole pixel.
 * Used when no user-dragged width has been set yet.
 * @param viewportWidth  Current viewport width in pixels
 */
export function defaultDockWidth(viewportWidth: number): number {
  return Math.round(viewportWidth * DOCK_MIN_WIDTH_RATIO);
}

/**
 * Returns the send-button icon src path.
 * Active (text present) → filled arrow-up; inactive → dimmed arrow-up.
 * @param hasText  Whether the input has non-empty text
 */
export function getSendIconSrc(hasText: boolean): string {
  return hasText ? 'images/arrow-up.svg' : 'images/arrow-up-active.svg';
}


/**
 * Returns the send-button icon as a full <img> HTML string.
 * Used by components whose suffix-icon input expects innerHTML (e.g. TextInputComponent).
 * @param hasText  Whether the input has non-empty text
 */
export function getSendIconHtml(hasText: boolean): string {
  return `<img src="${getSendIconSrc(hasText)}" alt="send" width="30" height="30">`;
}
